class WCLoginService {
    constructor() {
        this.baseURL = process.env.REACT_APP_WC_SITE_URL;
        this.consumerKey = process.env.REACT_APP_WC_CK;
        this.consumerSecret = process.env.REACT_APP_WC_CS;
        this.inProgress = false;
    }

    // async registerCustomer(customerData) {
    //     try {
    //         const response = await fetch(`${this.baseURL}/wp-json/wc/v3/customers`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': 'Basic ' + btoa(`${this.consumerKey}:${this.consumerSecret}`)
    //             },
    //             body: JSON.stringify(customerData)
    //         });
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }
    //         return await response.json();
    //     } catch (error) {
    //         console.error('Error registering customer:', error);
    //         throw error;
    //     }
    // }
    async registerCustomer(customerData) {
        try {
            const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(`${this.consumerKey}:${this.consumerSecret}`)
                },
                body: JSON.stringify(customerData)
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return await response.json();
        } catch (error) {
            console.error('Error registering customer:', error);
            throw error;
        }
    }

    async loginCustomer(username, password) {
        this.inProgress = true;
        const response = await fetch(`${this.baseURL}/wp-json/jwt-auth/v1/token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username: username, password: password })
        });
        return await response.json();
    }

    async resetPassword(email, newPassword) {
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/reset_password`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email: email, newPassword: newPassword })
        });
        return await response.json();
    }
    async resetPasswordEmail(email) {
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/reset_password_email`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email })
        });
        return await response.json();
    }

    async checkCredentialsForResettingPassword(email, token) {
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/check_token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email:  email, token:  token })
        });
        return await response.json();
    }
}

export default new WCLoginService();